import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { HeaderComponent, FooterComponent, ExpectDialog, VersionDialog, FindIdDialog } from '../../shared-component';
import AppTool from '@/apps/@utils/app-tool';
import { useVoucher } from './useVoucher';
import { Table } from './Table';
import { PopupLayout } from '../../shared-component';

const VoucherPage = () => {
  const navigate = useNavigate();
  const popupRef = useRef(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [isHistorySearch, setIsHistorySearch] = useState(false);
  const [voucherCode, setVoucherCode] = useState('');
  const [friendId, setFriendId] = useState('');
  const [popup, setPopup] = useState(null);
  const view = searchParams.get('view') ?? '1';

  const openPopup = (errorType) => {
    setPopup(errorType)
    popupRef.current.open()
  }
  
  const {
    userProfile,
    voucherHistory,
    redeemVoucher,
    getVoucherHistory,
    loginUser
  } = useVoucher({ openPopup });

  const handleFriendIdChange = (e) => {
      const value = e.target.value;
      if (/^[0-9]*$/.test(value)) {
          setFriendId(value);
      }
  };

  const handleVoucherCodeChange = (e) => {
      const value = e.target.value;
      if (/^[a-zA-Z0-9]*$/.test(value)) {
        setVoucherCode(value);
      }
  };

  const handleUserlogin = async () => {
    const isLoginSuccess = await loginUser(friendId)
    if (isLoginSuccess) {
      setSearchParams({view: '2'})
    }
  }

  const handleRedeemVoucher = async () => {
    const isSuccess = await redeemVoucher(voucherCode)
    if (isSuccess) {
      setVoucherCode('')
    }
  }

  useEffect(()=>{
    if (parseInt(view) >= 2 && !userProfile?.friend_id) {
      navigate('/voucher')
    }
  },[view])

  useEffect(()=>{
    if (isHistorySearch) {
      getVoucherHistory()
    }
  },[isHistorySearch])

  useEffect(() => {
    setTimeout(() => { AppTool.closeLoadingDialog('.cLoadingDialog') }, 2000);
  }, []);

  return (
    <div className="cVoucherPage">
      <ExpectDialog />
      <HeaderComponent />
      <VersionDialog />
      <FindIdDialog />
      <PopupLayout ref={popupRef}>
        {popup &&
          <img className='cPopup' src={window.assetUrl(`/images/voucher-page/popup/${popup}.png`)} alt='' />
        }
      </PopupLayout>
      <div className="cContent">
        <div className="cBackground">
          <img className="pc" src={window.assetUrl('/images/voucher-page/pc/bg.jpg')} alt='' />
          <img className="mb" src={window.assetUrl('/images/voucher-page/mobile/bg.jpg')} alt='' />
        </div>
        {view === '1' ?
          <div className='cVoucherSection'>
            <img className='TitleText' src={window.assetUrl('/images/voucher-page/TitleText.png')} alt='' />
            <label className='vFriend'>請輸入您的好友ID</label>
            <input
                placeholder='01234567891'
                className='FriendInput'
                type='text'
                maxLength={11}
                value={friendId}
                onChange={handleFriendIdChange}
            />
            <label className='cInputNotes'>* 好友ID為11碼純數字，無英文字母與符號。</label>
            <div className='cLoginBtn' onClick={()=>handleUserlogin()}>
              <img src={window.assetUrl('/images/voucher-page/LoginBtn.png')} alt='' />
            </div>
            <div className='cFindId' onClick={()=>AppTool.openDialog('.cFindIdDialog')}>
              <img src={window.assetUrl('/images/voucher-page/Find.png')} alt='' />
            </div>
          </div>
        : view === '2' ?
          <div className='cVoucherSection'>
            {isHistorySearch ?
              <img className='ExchangeTitleText' src={window.assetUrl('/images/voucher-page/ExchangeTitleText.png')} alt='' />
              :
              <img className='TitleText' src={window.assetUrl('/images/voucher-page/TitleText.png')} alt='' />
            }
            <div className={`cPlayerInfo ${isHistorySearch ? ' history' : ''}`}>
              <label className='iText'>目前登入的帳戶為：</label>
              <label className='iText'>[ {userProfile?.friend_id} ]</label>
              <label className='iText'>[ {userProfile?.player_name} ]</label>
              {isHistorySearch ?
                <div className='cBackBtn' onClick={()=>setIsHistorySearch(false)}>
                  <img src={window.assetUrl('/images/voucher-page/BackBtn.png')} alt='' />
                </div>
                :
                <div className='cHistoryBtn' onClick={()=>setIsHistorySearch(true)}>
                  <img src={window.assetUrl('/images/voucher-page/HistoryBtn.png')} alt='' />
                </div>
              }
            </div>
            {isHistorySearch ?
              <Table voucherHistory={voucherHistory} />
              :
              <React.Fragment>
                <label className='vInputTitle'>請輸入兌換的序號</label>
                <input
                    placeholder='請在此輸入序號'
                    className='FriendInput'
                    type='text'
                    maxLength={20}
                    value={voucherCode}
                    onChange={handleVoucherCodeChange}
                    style={{marginTop: '2.5%'}}
                />
                <div className='cLoginBtn' onClick={()=>handleRedeemVoucher()}>
                  <img src={window.assetUrl('/images/voucher-page/SentBtn.png')} alt='' />
                </div>
                <div className='cVoucherNotes'>
                  <img className='pc' src={window.assetUrl('/images/voucher-page/pc/Notice.png')} alt='' />
                  <img className='mb' src={window.assetUrl('/images/voucher-page/mobile/Notice.png')} alt='' />
                </div>
              </React.Fragment>
            }
          </div>
        : null
        }
      </div>
      <FooterComponent />
    </div>
  );
};

export default VoucherPage;

